// extracted by mini-css-extract-plugin
export default {"textArea":"TextArea_textArea__7KqbV"};